export default __webpack_public_path__ + "static/media/installation_firefox3.76cdc781.jpg";